import React from 'react';
import classNames from 'classnames';
import omit from '../util/omit';
import Element from './Element';
import ConfigContext from './configContext';

const SkeletonAvatar = props => {
  const renderSkeletonAvatar = ({ getPrefixCls }) => {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const otherProps = omit(props, ['prefixCls']);
    const cls = classNames(
      prefixCls,
      `${prefixCls}-element`,
      { [`${prefixCls}-active`]: active },
      className,
    );
    return (
      <div className={cls}>
        <Element prefixCls={`${prefixCls}-avatar`} {...otherProps} />
      </div>
    );
  };
  return <ConfigContext.Consumer>{renderSkeletonAvatar}</ConfigContext.Consumer>;
};
SkeletonAvatar.defaultProps = {
  size: 'default',
  shape: 'circle',
};
export default SkeletonAvatar;



// WEBPACK FOOTER //
// ./src/skeleton/Avatar.jsx